import axios from "./axiosInstance";
import config from "./config";
import { captureException } from "../utils/sentry";

const BASE_URL = config.BASE_URL;

const getHeaders = (token: string) => ({
  "Content-Type": "application/json",
  authorization: `Bearer ${token}`,
});

export type UserPreferences = Record<string, unknown>;

export const fetchUserPreferences = async (
  token: string
): Promise<UserPreferences | null> => {
  try {
    const response = await axios.get(`${BASE_URL}/users/me/preferences`, {
      headers: getHeaders(token),
    });
    return response.data?.data || {};
  } catch (err) {
    captureException(err);
    return null;
  }
};

// Shallow merge — pass only the keys you want to update.
export const patchUserPreferences = async (
  token: string,
  partial: UserPreferences
): Promise<UserPreferences | null> => {
  try {
    const response = await axios.patch(
      `${BASE_URL}/users/me/preferences`,
      partial,
      { headers: getHeaders(token) }
    );
    return response.data?.data || null;
  } catch (err) {
    captureException(err);
    return null;
  }
};
